/**
 * @enum {number}
 */
const LoadImageActionType = Object.freeze({
    UPLOAD: 0,
    URL: 1,
    CLIPBOARD: 2,
    BASE64: 3
})

export default LoadImageActionType;